<h2 mat-dialog-title>GUID Picker</h2>
<mat-dialog-content class="content">
  <mat-form-field appearance="outline">
    <mat-label>Field Key</mat-label>
    <input matInput [(ngModel)]="fieldKey" (ngModelChange)="onFieldKeyChange()" placeholder="e.g. brandId, userId">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Lookup Source</mat-label>
    <mat-select [(ngModel)]="sourceKey" (selectionChange)="onSourceChange()">
      <mat-option *ngFor="let source of sources" [value]="source.key">{{source.label}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="query" (ngModelChange)="onQueryChange()" placeholder="Type to filter">
  </mat-form-field>

  <div class="status" *ngIf="loading">Loading...</div>
  <div class="status error" *ngIf="errorMessage">{{errorMessage}}</div>

  <mat-list>
    <mat-list-item *ngFor="let item of results; trackBy: trackById" (click)="insertItem(item)">
      <div class="item">
        <div class="label">{{item.label || '(no label)'}}</div>
        <div class="id">{{item.id}}</div>
      </div>
    </mat-list-item>
    <div class="empty" *ngIf="!loading && results.length === 0">No matches.</div>
  </mat-list>

  <mat-card *ngIf="selected" class="selected">
    <mat-card-title>Selected</mat-card-title>
    <mat-card-content>
      <div class="label">{{selected.label}}</div>
      <div class="id">{{selected.id}}</div>
      <div class="actions">
        <button mat-raised-button color="primary" (click)="insertSelected()">Insert</button>
        <button mat-stroked-button (click)="copySelected()">Copy</button>
      </div>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">Close</button>
</mat-dialog-actions>
